(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    // Sync quantity input value to product-form-component attribute
    document.querySelectorAll('product-form-component').forEach((form) => {
      const qtyInput = form.querySelector('[name="quantity"]');
      if (!qtyInput) return;

      function syncQty() {
        form.setAttribute('data-quantity-default', qtyInput.value);
      }

      qtyInput.addEventListener('change', syncQty);
      qtyInput.addEventListener('input', syncQty);
      new MutationObserver(syncQty).observe(qtyInput, {
        attributes: true,
        attributeFilter: ['value'],
      });
    });

    // Dynamic price update based on quantity
    const sections = document.querySelectorAll('.shopify-section');

    sections.forEach((section) => {
      const quantityInput = section.querySelector('[name="quantity"]');
      const priceContainer = section.querySelector(
        'product-price [ref="priceContainer"]'
      );

      if (!quantityInput || !priceContainer) return;

      const priceSpan = priceContainer.querySelector('.price');
      if (!priceSpan) return;

      const originalPriceText = priceContainer.textContent.trim();

      // Extract numeric price from formatted text
      function extractPrice(text) {
        const match = text.match(/([\d\s,.]+(?:[.,]\d{2})?)/);
        if (!match) return null;
        const value = match[1]
          .replace(/\s/g, '')
          .replace(/\./g, '')
          .replace(',', '.');
        return parseFloat(value);
      }

      const basePrice = extractPrice(originalPriceText);
      if (!basePrice) return;

      // Extract currency symbol/string
      const currencyMatch = originalPriceText.match(/[^\d\s,.]+/g);
      const currency = currencyMatch ? currencyMatch[0] : '';

      // Format price back to locale format
      function formatPrice(value) {
        const formatted = value.toFixed(2);
        const parts = formatted.split('.');
        const intPart = parseInt(parts[0]).toLocaleString('de-DE');
        const decPart = parts[1];
        return `${intPart},${decPart} ${currency}`.trim();
      }

      // Update displayed price
      function updatePrice() {
        const qty = parseInt(quantityInput.value) || 1;
        priceSpan.textContent = formatPrice(basePrice * qty);
      }

      // Listen for all relevant quantity change events
      quantityInput.addEventListener('input', updatePrice);
      quantityInput.addEventListener('change', updatePrice);
      quantityInput.addEventListener('QuantitySelectorUpdateEvent', (e) => {
        const qty = e.detail || parseInt(quantityInput.value) || 1;
        priceSpan.textContent = formatPrice(basePrice * qty);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
